// Encode data as Base64
function encodeBase64(data) {
  return btoa(unescape(encodeURIComponent(data)));
}

// Decode Base64 data
function decodeBase64(encodedData) {
  return decodeURIComponent(escape(atob(encodedData)));
}

const storeToken = (value) => {
  localStorage.setItem("access_token", value);
};

const getToken = () => {
  let access_token = localStorage.getItem("access_token");
  return { access_token };
};

const paymentdata = (value) => {
  localStorage.setItem("payment_details", JSON.stringify(value));
  console.log(value);
};

const getpaymentdata = () => {
  let payment_details = JSON.parse(localStorage.getItem("payment_details"));
  return { payment_details };
};

const removeToken = () => {
  localStorage.clear();
  localStorage.clear();
};

const setProfile = (value) => {
  // Encode profile as Base64 before storing
  const encodedProfile = encodeBase64(JSON.stringify(value));
  localStorage.setItem("profile", encodedProfile);
};

const setAddToCart = (value) => {
  let addToCart = [];

  // Retrieve and decode the current array from local storage
  const encodedAddToCart = localStorage.getItem("Addtocart");
  if (encodedAddToCart) {
    try {
      // Decode and parse the existing array
      const decodedString = decodeBase64(encodedAddToCart);
      addToCart = JSON.parse(decodedString);

      // Check if the parsed data is an array
      if (!Array.isArray(addToCart)) {
        console.error("Parsed data is not an array. Resetting to empty array.");
        addToCart = [];
      }
    } catch (error) {
      console.error("Failed to decode or parse Addtocart:", error);
      addToCart = []; // Reset to empty array on error
    }
  }

  // Add the new value to the array
  addToCart.push(value);

  // Encode and store the updated array back in local storage
  const encodedAddToCartNew = encodeBase64(JSON.stringify(addToCart));
  localStorage.setItem("Addtocart", encodedAddToCartNew);
};


const getAddToCart = () => {
  let addToCart = [];

  // Retrieve and decode the array from local storage
  const encodedAddToCart = localStorage.getItem("Addtocart");
  if (encodedAddToCart) {
    try {
      // Decode and parse the array
      const decodedString = decodeBase64(encodedAddToCart);
      addToCart = JSON.parse(decodedString);

      // Check if the parsed data is an array
      if (!Array.isArray(addToCart)) {
        console.error("Parsed data is not an array. Returning empty array.");
        addToCart = [];
      }
    } catch (error) {
      console.error("Failed to decode or parse Addtocart:", error);
      addToCart = []; // Return empty array on error
    }
  }

  return addToCart;
};
const getProfile = () => {
  let profile = "";

  const encodedProfile = localStorage.getItem("profile");
  if (encodedProfile) {
    try {
      // Decode Base64 and parse JSON
      profile = JSON.parse(decodeBase64(encodedProfile));
    } catch (error) {
      console.error("Failed to decode or parse profile:", error);
    }
  }
  return { profile };
};
export {
  storeToken,
  getToken,
  removeToken,
  setProfile,
  getProfile,
  paymentdata,
  getpaymentdata,
  setAddToCart,
  getAddToCart
};
